import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { HttpService } from './http.service';
// import { AppVersion } from '@ionic-native/app-version';
@Injectable()
export class PlatformService {
    constructor( private platform: Platform, private http: HttpService ) {} // , private appVersion: AppVersion

    get_platform(callback: (body: any) => void) {
        let platformType = 'web';
// if (!this.platform.is('cordova')) 앱이 아닌겨우

        this.platform.ready().then(() => {
            if (this.platform.is('cordova')) {
                if (this.platform.is('android')) {
                    platformType = 'android';
                } else if (this.platform.is('ios')) {
                    platformType = 'ios';
                }
            } else if (this.platform.is('mobile')) { // mobileweb 브라우저 실행 일경우
                platformType = 'web'; // mobileweb
            }
            callback(platformType);
            return;
        });

        callback(platformType);
    }

    version(callback: (body: any) => void) {
        this.get_platform((platform) => {
                if (platform !== 'web') {
                    // this.appVersion.getVersionNumber().then(function (version) {
                    //    callback(version);
                    // });
                    callback('1.0.0');
                }
        });

    }

    latestVersion(callback: (body: any) => void) { // 서버로 부터 세팅되어 있는 값을 가지고 온다.
        this.http.get({url: 'ver'}).then((res) => {
            callback(res);
        });
    }

}
